import StatusPharmacy from './StatusPharmacy';

export default StatusPharmacy;
